import { createEvent, createStore } from 'effector'
import googleMapReact from 'google-map-react'

export const actions = {
  setMapZoom: createEvent<number>('setZoom'),
  setCenter: createEvent<googleMapReact.Coords>('setCenter'),
  setSouthWestBound: createEvent<LatLng>('setSouthWestBound'),
  setNorthEastBound: createEvent<LatLng>('setNorthEastBound'),
  reset: createEvent('reset'),
}

const initialState: Localisation = {
  center: {
    lat: 47.09,
    lng: 2.25,
  },
  mapZoom: 6,

  // Coordonnées géographiques de la France métropolitaine
  southWestBound: { lat: 42.2, lng: -5 },
  northEastBound: { lat: 51.1, lng: 10 },
}

export const store = createStore<Localisation>(initialState)
  .on(actions.setMapZoom, (loc, mapZoom) => ({ ...loc, mapZoom }))
  .on(actions.setCenter, (loc, center) => ({ ...loc, center }))
  .on(actions.setSouthWestBound, (loc, southWestBound) => ({ ...loc, southWestBound }))
  .on(actions.setNorthEastBound, (loc, northEastBound) => ({ ...loc, northEastBound }))
  .on(actions.reset, () => ({ ...initialState }))
